module.exports = __webpack_public_path__ + "img/theme7.fbbae3e7.png";